import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlaintext',
    standalone: false
})
export class HtmlToPlaintextPipe implements PipeTransform {
    /**
     * Transform
     *
     * param {string} value
     * param {any[]} args
     * returns {string}
     */
    transform(value: string, args: any[] = []): string {
        if (!value) return '';

        // Replace </p><p> with a newline
        let plainText = value.replace(/<\/p>\s*<p>/gi, '\n');

        // Remove remaining <p>, </p>, <br>, and other HTML tags
        plainText = plainText.replace(/<\/?p>/gi, '');
        plainText = plainText.replace(/<br\s*\/?>/gi, '\n');
        plainText = plainText.replace(/<[^>]+>/g, '');

        return plainText.trim();
    }
}
